/**
 * @param {Number} n
 * @param {Number} m
 * @returns {Number}
 * Returns correct modulo for negative numbers.
 * -1 % 7 = -1
 * mmod(-1,7) = 6
 */
const mmod = (n, m) => {
    return ((n % m) + m) % m;
};
export class HistoryBuffer {
    /**@type {Number} */
    capacity = 0;
    /**@type {ImageData[]} */
    buffer;
    /**@type {Number} */
    #startIdx = 0;
    /**@type {Number} */
    #endIdx = 0;
    /**@type {Number} */
    size = 0;
    /**@type {Number} */
    pointer = 0;
    constructor(capacity = 6) {
        this.capacity = capacity;
        this.buffer = new Array(this.capacity);
        this.#startIdx = 0;
        this.#endIdx = 0;
    }
    #countFromStartToPnt() {
        return mmod(this.pointer - this.#startIdx, this.capacity) + 1;
    }
    push(item) {
        let count = this.#countFromStartToPnt();
        this.pointer =
            this.size !== 0
                ? (this.#startIdx + this.#countFromStartToPnt()) % this.capacity
                : 0;

        this.buffer[this.pointer] = item;
        if (count === this.capacity)
            this.#startIdx = mmod(this.#startIdx + 1, this.capacity);
        // this.size = ((this.#startIdx + this.pointer) % this.capacity) + 1;
        this.size = this.#countFromStartToPnt();
    }
    undo() {
        if (this.pointer === null) {
            throw Error("No elements in HistoryBuffer");
        }
        if (this.pointer === this.startIdx) return null;
        this.pointer = mmod(this.pointer - 1, this.capacity);
        return this.buffer[this.pointer];
    }
    redo() {
        if (this.lastIdx() === this.pointer) return null;
        this.pointer = mmod(this.pointer + 1, this.capacity);
        return this.buffer[this.pointer];
    }
    lastIdx() {
        if (this.size === 0) return -1;
        return (this.#startIdx + this.size - 1) % this.capacity;
    }
    #pntInc() {
        this.pointer = (this.pointer + 1) % this.capacity;
    }
    get current() {
        if (this.pointer === null) return null;
        return this.buffer[this.pointer];
    }

    get startIdx() {
        return this.#startIdx;
    }
    //Method for testing in console
    static test1() {
        let size = 5;
        let hb = new HistoryBuffer(size);
        for (let i = 0; i < size; ++i) {
            hb.push((i + 1) * 10);
        }
        return hb;
    }
}
// window["HistoryBuffer"] = HistoryBuffer;
